export default "# Snackbar\n\n::demo{name=snackbar}\n"